const TemplateToolbar = ({
    onPreview,
    onReset,
}) => {

    return (

        <div className="d-flex gap-2">

            <button
                className="btn btn-primary"
                type="button"
                onClick={onPreview}
            >
                Preview
            </button>

            <button
                className="btn btn-danger"
                type="button"
                onClick={onReset}
            >
                Reset
            </button>

        </div>

    );

};

export default TemplateToolbar;